module.exports = "/assets/09a3a605d12b812b20e3029b054e49d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/UZ.png
// module id = 1909
// module chunks = 0